<template>
  <div class="echarts-container">
    <div
      ref="chart"
      :style="{ width: width, height: height }"
      class="chart"
    ></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'ECharts',
  props: {
    // 图表配置项
    option: {
      type: Object,
      required: true
    },
    // 图表宽度
    width: {
      type: String,
      default: '100%'
    },
    // 图表高度
    height: {
      type: String,
      default: '400px'
    },
    // 主题
    theme: {
      type: String,
      default: null
    },
    // 是否自动调整大小
    autoresize: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      chartInstance: null,
      resizeTimer: null
    }
  },
  mounted() {
    this.initChart()
    if (this.autoresize) {
      window.addEventListener('resize', this.handleResize)
    }
  },
  beforeDestroy() {
    this.disposeChart()
    if (this.autoresize) {
      window.removeEventListener('resize', this.handleResize)
    }
  },
  watch: {
    // 监听图表配置项变化
    option: {
      handler(newOption) {
        this.updateChart(newOption)
      },
      deep: true
    },
    // 监听主题变化
    theme(newTheme) {
      this.disposeChart()
      this.initChart(newTheme)
    }
  },
  methods: {
    // 初始化图表
    initChart(theme) {
      try {
        this.chartInstance = echarts.init(this.$refs.chart, theme || this.theme)
        this.chartInstance.setOption(this.option)
        
        // 转发 ECharts 事件
        this.chartInstance.on('click', (params) => {
          this.$emit('click', params)
        })
        this.chartInstance.on('dblclick', (params) => {
          this.$emit('dblclick', params)
        })
        this.chartInstance.on('mousedown', (params) => {
          this.$emit('mousedown', params)
        })
        this.chartInstance.on('mousemove', (params) => {
          this.$emit('mousemove', params)
        })
        this.chartInstance.on('mouseup', (params) => {
          this.$emit('mouseup', params)
        })
        this.chartInstance.on('mouseover', (params) => {
          this.$emit('mouseover', params)
        })
        this.chartInstance.on('mouseout', (params) => {
          this.$emit('mouseout', params)
        })
        this.chartInstance.on('globalout', (params) => {
          this.$emit('globalout', params)
        })
        this.chartInstance.on('contextmenu', (params) => {
          this.$emit('contextmenu', params)
        })
      } catch (error) {
        console.error('初始化图表失败:', error)
      }
    },
    // 更新图表
    updateChart(option) {
      if (this.chartInstance) {
        this.chartInstance.setOption(option, { notMerge: true })
      }
    },
    // 销毁图表
    disposeChart() {
      if (this.chartInstance) {
        this.chartInstance.dispose()
        this.chartInstance = null
      }
    },
    // 处理窗口大小变化
    handleResize() {
      clearTimeout(this.resizeTimer)
      this.resizeTimer = setTimeout(() => {
        if (this.chartInstance) {
          this.chartInstance.resize()
        }
      }, 200)
    },
    // 主动调整图表大小
    resize() {
      if (this.chartInstance) {
        this.chartInstance.resize()
      }
    },
    // 获取图表实例
    getChartInstance() {
      return this.chartInstance
    },
    // 保存图表为图片
    saveAsImage(params) {
      if (this.chartInstance) {
        return this.chartInstance.getDataURL(params)
      }
      return null
    },
    // 开始图表动画
    startAnimation() {
      if (this.chartInstance) {
        this.chartInstance.dispatchAction({ type: 'start' })
      }
    },
    // 停止图表动画
    stopAnimation() {
      if (this.chartInstance) {
        this.chartInstance.dispatchAction({ type: 'stop' })
      }
    }
  }
}
</script>

<style scoped>
.echarts-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.chart {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>